import { useEffect, useRef } from 'react';
import { useActiveCanvas } from './use-active-canvas';

export const useHeaderClick = () => {
  const activeCanvas = useActiveCanvas();
  const headerParentRef = useRef<HTMLDivElement>(null);

  const handleClickInsideHeader = () => {
    if (activeCanvas?.current?.getActiveObject()) {
      activeCanvas?.current?.discardActiveObject().requestRenderAll();
    }
  };

  useEffect(() => {
    const clickOrTouch = 'ontouchstart' in window ? 'touchstart' : 'click';
    headerParentRef?.current?.addEventListener(clickOrTouch, handleClickInsideHeader);
    return () => {
      document.removeEventListener(clickOrTouch, handleClickInsideHeader);
    };
  }, [activeCanvas]);

  return headerParentRef;
};
